"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INSTALL_PAGE = exports.OUTLOOK_365_OAUTHOR_BASE = exports.GMAIL_OAUTHOR_BASE = exports.getInboxConnectPath = void 0;

var _enviro = _interopRequireDefault(require("enviro"));

var _protocol = 'https://';

var _domainSuffix = _enviro.default.get() === 'development' ? 'qa' : '';

var HS_APP = _protocol + "app.hubspot" + _domainSuffix + ".com";

var getInboxConnectPath = function getInboxConnectPath(portalId) {
  return "/inbox-connect/" + portalId;
};

exports.getInboxConnectPath = getInboxConnectPath;
var GMAIL_OAUTHOR_BASE = HS_APP + "/oauthor/v1/google/start";
exports.GMAIL_OAUTHOR_BASE = GMAIL_OAUTHOR_BASE;
var OUTLOOK_365_OAUTHOR_BASE = HS_APP + "/oauthor/v1/office365/start";
exports.OUTLOOK_365_OAUTHOR_BASE = OUTLOOK_365_OAUTHOR_BASE;

var INSTALL_PAGE = function INSTALL_PAGE(portalId) {
  var provider = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'unknown';
  return HS_APP + "/crm-settings-email/" + portalId + "/email/extension?installwizardprovider=" + provider;
};

exports.INSTALL_PAGE = INSTALL_PAGE;